import React from 'react';

import messages from './messages';
import ReusableGridButton from '../../../components/grid-header/reusable-grid-button';
import { useModal } from '../../../hooks/use-modal';
import Global from '../../../store/global-selectors';
import { useSelector } from 'react-redux';
import { CreateCustomerModal } from '../modals/create-customer-modal';

export const CreateCustomerButton = () => {
  const { open, isOpen, close } = useModal();
  const hasCustomerManagementRole = useSelector(Global.selectUserhasCustomerManagementRole);

  return (
    <>
      <ReusableGridButton
        actionHandler={open}
        disable={!hasCustomerManagementRole}
        messageDescriptor={messages.createCustomer}
        theme='tertiary'
      />
      {isOpen ? <CreateCustomerModal modalFrameworkMethods={{ closeModal: close }} source='customers_grid' /> : null}
    </>
  );
};
